import { TopicId } from '~/dashboard/utils/learningPath.utils'

export const administrationPhoneNumber = '+47 22 150 300'

export const mathTopicsData = [
  {
    iconKey: 'math-topics/algebra-v3.png',
    key: TopicId.ALGEBRA,
    href: '/math-topics#algebra',
    iconAlt: 'algebra',
  },
  {
    iconKey: 'math-topics/geometry-v3.png',
    key: TopicId.GEOMETRY,
    href: '/math-topics#geometry',
    iconAlt: 'geometry',
  },
  {
    iconKey: 'math-topics/numbersAndQuantities-v3.png',
    key: TopicId.NUMBERS,
    href: '/math-topics#numbersAndQuantities',
    iconAlt: 'nq',
    altKey: 'numbersAndQuantities',
  },
  {
    iconKey: 'math-topics/statisticsAndProbability-v3.png',
    key: TopicId.STATISTICS,
    href: '/math-topics#statisticsAndProbability',
    iconAlt: 'stats',
    altKey: 'statisticsAndProbability',
  },
  {
    iconKey: 'math-topics/functions-v3.png',
    key: TopicId.FUNCTIONS,
    href: '/math-topics#functions',
    iconAlt: 'functions',
  },
  {
    iconKey: 'math-topics/proofs-v3.png',
    key: TopicId.PROOFS,
    href: '/math-topics#proofs',
    iconAlt: 'proofs',
  },
]
